/**
 * @file CartOrderInfoSlot.tsx
 *
 * @fileoverview This component renders additional things to the cart order info component. Can be used
 * for example to run custom
 */
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { CommerceOrder } from '~/jobiqo/types/types';

interface CartOrderInfoSlotProps {
  /**
   * The commerce order.
   */
  order: Slottable<CommerceOrder>;
}

export default function CartOrderInfoSlot({ order }: CartOrderInfoSlotProps) {
  return null;
}

export { CartOrderInfoSlot };
